import { useQuery } from "@tanstack/react-query";
import queryKey from "../enumerations/queryKey";
import { apiGetOpenedGameCategory } from "./service";

export const useGetOpenedGameCategory = ({ options }) => {
  return useQuery(
    [queryKey.OPENED_GAME_CATEGORY],
    () => apiGetOpenedGameCategory().then((res) => res.data.data),
    {
      ...options,
    },
  );
};
